import HeadlessModal from '@Shared/Components/Modals/HeadlessModal';
import GoogleRecaptcha from '@Web/Src/Components/GoogleRecaptcha';
import { useForm, usePage } from '@inertiajs/react';
import Button from '@Web/Src/Components/Button';
import Input from '@Web/Src/Components/Input';
import { useEffect, useState } from 'react';
import axios from 'axios';

function GenerateCampaignInput({ className = '', redirect_to = 'demo' }) {
    const { data, setData, post } = useForm({
        url: '',
        'g-recaptcha-response': '',
    });

    const isAuth = usePage().props.auth.customer;

    const hasErrors = () => {
        return Object.keys(error).length > 0;
    };

    const [error, setError] = useState({});
    const [showLoader, setShowLoader] = useState(false);

    const handleErrors = {
        onError: (error) => {
            setError(error);
            setShowLoader(false);
        },
    };
    const sendRequest = async () => {
        setTimeout(() => {
            if (hasErrors()) {
                if (!recaptchaEnabled) {
                    alert(
                        Object.entries(error)
                            .map((item) => item[1])
                            .join('\n')
                    );
                }

                return false;
            }
            setShowLoader(true);
        }, 1000);

        if (redirect_to === 'embed') {
            try {
                const resp = await axios.post(route('web.campaigns.demo-campaign.store'), {
                    redirectTo: redirect_to,
                    url: data.url,
                    'g-recaptcha-response': data['g-recaptcha-response'],
                });

                window.parent.postMessage(resp.data.data, import.meta.env.VITE_APP_URL);
            } catch (err) {
                console.warn(err);
            }
        } else {
            post(
                route('web.campaigns.demo-campaign.store', {
                    redirectTo: isAuth ? 'register' : redirect_to,
                }),
                handleErrors
            );
        }
    };

    useEffect(() => {
        if (data['g-recaptcha-response'] === '') return;
        sendRequest();
    }, [data['g-recaptcha-response']]);

    const [showModal, setShowModal] = useState(false);

    const recaptchaEnabled = !['false', false, 0, '0', ''].includes(
        import.meta.env.VITE_GOOGLE_RECAPTCHA_ENABLED
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!data.url.trim()) {
            return;
        }

        if (recaptchaEnabled) {
            setShowModal(true);
        } else {
            sendRequest();
        }
    };

    const handleSubmitReCaptcha = (value) => {
        setData('g-recaptcha-response', value);
    };

    return (
        <div className={`relative ${className}`}>
            <form onSubmit={handleSubmit}>
                <Input
                    required
                    onChange={(e) => setData('url', e.target.value)}
                    value={data['url']}
                    placeholder={__('Enter your website...')}
                    inputClassName='!pl-6 !h-14 rounded-[36px]'
                    rightSpace='!pr-[150px]'
                />
                <Button
                    type='submit'
                    name={__('Build referral program')}
                    className='absolute right-1 top-1 h-12 min-w-32 rounded-[36px] px-5'
                />
            </form>
            <HeadlessModal
                centered={true}
                closeIcon={false}
                closeOnOverlayClick={true}
                className='max-w-lg rounded-sm'
                show={showModal}
                closeOnEsc
                onClose={() => {
                    setError({});
                    setShowLoader(false);
                    setShowModal(false);
                }}
            >
                <div>
                    <GoogleRecaptcha onChange={handleSubmitReCaptcha} />
                    {(hasErrors() || showLoader) && (
                        <div className='mr-0.5 bg-white/70 px-3 py-2 font-sans'>
                            {hasErrors() && (
                                <div className='text-red text-sm leading-5'>
                                    {Object.entries(error).map((item, index) => {
                                        return (
                                            <div key={index}>
                                                {index + 1}.&nbsp;{item[1]}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            {showLoader && (
                                <div className='text-sm'>{__('Please wait...')}</div>
                            )}
                        </div>
                    )}
                </div>
            </HeadlessModal>
        </div>
    );
}

export default GenerateCampaignInput;
